import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { HeaderAndIconsCardStoryblok } from '../../../../types/storyblok';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';
import { Type } from '../../../../base/Type/Type';

export const HeaderAndIconsCard = ({
  heading,
  image,
}: HeaderAndIconsCardStoryblok) => {
  if (!heading && !image) {
    return null;
  }

  return (
    <Box as="section" className="flex flex-col gap-5">
      <StoryblokImage src={image} alt="" mode="responsive" maxWidth={600} />
      <Type as="h3" className="text-p1">
        {heading}
      </Type>
    </Box>
  );
};

export default HeaderAndIconsCard;
